import React from "react";
import { Spin } from "antd";

export const SpinPage = () => {
  return (
    <div
      style={{
        minHeight: "80vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Spin size="large" style={{ fontSize: "200px" }} />
    </div>
  );
};
